import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'
import { IGrade, IReportTheme, ISubject, ITheme } from 'interfaces'
import { useEffect, useState } from 'react'
type EditThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
}

export const EditTheme: React.FC<EditThemeProps> = ({ modalProps, formProps, record }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  useEffect(() => {
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ]
    setSubjectFilter(data)
  }, [record])
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  // const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   filters: subjectFilter,
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const handleSubjectChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      report_theme_id: null,
    })
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
  }
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.subject_id) {
      values.name = values?.name?.trim()
      const isNameStillSame = values?.name === formProps?.initialValues?.name
      if (!isNameStillSame) {
        const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'themes')
        if (isNameRepeated && isNameRepeated?.themes?.length > 0) {
          message.error('Theme name is already present... please make sure themes are unique')
          return false
        }
      }
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          updated_by: user?.id,
        })
      )
    } else {
      message.error(`Required fields are missing...`)
    }
  }
  return (
    <Modal {...modalProps} title="Edit Theme">
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('themes', 'edit', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Theme Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Subject" name="subject_id" rules={[{ required: true }]}>
          <Select {...subjectSelectProps} onChange={handleSubjectChange} />
        </Form.Item>
        {/*------------------ commenting report theme selection for now -----------------*/}
        {/* <Form.Item label="Report Theme" name="report_theme_id" rules={[{ required: true }]}>
          <Select {...reportThemeSelectProps} />
        </Form.Item> */}
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
